module.exports = __webpack_public_path__ + "img/rrheth nesh2 21.29cb8eb5.jpg";